import {
    NinchatEnvironmentConfig, NinchatEnvironmentConfigTheme,
} from 'embed/types'
import {embedDefault} from 'stitches/config.embed'
import {overrideEmbedTheme} from '../../stitches/overrideEmbedTheme'

export class ThemeManager {
    public theme: typeof embedDefault = {}

    public buildTheme = async (colorScheme: NinchatEnvironmentConfig['colorScheme'], themeOverrides: NinchatEnvironmentConfigTheme, isWebView: boolean) => {
        const themeVariables = overrideEmbedTheme(colorScheme, themeOverrides, isWebView)

        // dynamic import to prevent injecting <style> immediately when the app is loaded
        const {createTheme} = await import('stitches/config')
        const theme = createTheme('embed', themeVariables)
        this.theme = theme
    }

    public getTheme = () => this.theme
}

